import { questData } from 'Project/Game/data/gameData';

export const findQuest = (id) => {
  let fullQuestData = questData.find(questData => id === questData.id);
  return fullQuestData;
}
